<template>
  <form-item-facade
    class="textarea-item"
    :name="name"
    :errors="errors"
  >
    <textarea-facade
      v-model="model"
      :disabled="disabled"
      :id="name"
      :max-length="maxLength"
      :placeholder="placeholder"
    />
  </form-item-facade>
</template>

<script setup>
  import { defineModel } from 'vue';
  import FormItemFacade from "@/lib/ant-design-vue/components/FormItemFacade.vue";
  import TextareaFacade from "@/lib/ant-design-vue/components/TextareaFacade.vue";

  const model = defineModel();

  defineProps({
    // HTML-поле "name" для элемента формы.
    name: {
      type: [Array, String],
      required: true,
    },

    // Whether the textarea is disabled.
    disabled: {
      type: Boolean,
      default: false,
    },

    // Объект, обрабатывающий ошибки.
    errors: Object,

    // Максимальная длина текста в поле
    maxLength: {
      type: Number,
      default: 1000,
    },

    // Текст подсказки, что нужно вводить в поле
    placeholder: {
      type: String,
      default: '',
    },
  });
</script>